import { Component,ViewChild,EventEmitter, Input, Output } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { CaseDataService } from '../../../_dataservices/CaseDataService';
import { AppClientContext } from '../../../_appCommon/base/AppClientContext';
import { ListControllerBase } from '../../../_appCommon/base/ListControllerBase';
import { CustomerDataService } from '../../../_dataservices/CustomerDataService';
import {Status, StatusesID } from '../../../_appCommon/base/AppInterfaceAndBaseClasses';
import { Tools } from 'src/app-client/_appCommon/util/Tools';
import { StatusDataService } from 'src/app-client/_dataservices/StatusDataService';
import { MatPaginator } from '@angular/material/paginator';
import { StatusManagerService } from 'src/app-client/_dataservices/StatusManagerService';
import { CaseStageDataService } from 'src/app-client/_dataservices/CaseStageDataService';
import { BroadcastManager } from 'src/app-client/_appCommon/base/BroadcastManager';
import { AppEventNames } from 'src/app-client/_appCommon/base/Constants';
import { NgForm } from '@angular/forms';
import { AddressExceptionsDataService } from 'src/app-client/_dataservices/AddressExceptionDataService';
import { CustomerAddressDataService } from 'src/app-client/_dataservices/CustomerAddressDataService';
import { MatRadioChange } from '@angular/material/radio';
import { SystemConfigDataService } from 'src/app-client/_dataservices/SystemConfigDataService';
@Component({
  selector: 'app-case-list-home',
  templateUrl: './case-list-home.component.html',
  styleUrls: ['./case-list-home.component.css'],
  providers: [CaseStageDataService, StatusDataService,AddressExceptionsDataService,CustomerAddressDataService,SystemConfigDataService]
})
export class CaseListHomeComponent extends ListControllerBase<CaseDataService>{

  @ViewChild('table') protected table: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator;

  @Input() public caseId: number = 0;
  @Input() public availableAligners: number = 0;
  @Input() public isCaseExpired: boolean;
  @Input() public isFinalStatus: boolean = false;
  @Output() public stagesSelected = new EventEmitter<any[]>();
  @ViewChild('chooseSetupTypeDialog') protected chooseSetupTypeDialog: any;
  @ViewChild('approvalDialog') protected approvalDialog: any;
  @ViewChild('deleteDialog') protected deleteDialog: any;
  @ViewChild('suggestAlignersByAliwellDialog') protected suggestAlignersByAliwellDialog: any;
  @ViewChild('showShippingInfoDialog') protected showShippingInfoDialog: any;
  @ViewChild('alignersForm') public alignersForm: NgForm;
  @ViewChild('commentsAlignersByAliwellForm') public commentsAlignersByAliwellForm: NgForm;

  public case :any;
  public customerCases: any[];
  public customerId: number;
  public dataSource: MatTableDataSource<any>;

  public isLoading = false;

  public orderStatusToValidateAligners: number = 9;
  public statusIdToValidateAligners: number = 9;


  public searchByPatient: string = "";
  public searchByStatusType: string = "0";
  public searchValueById: string = "";
  public statusOptions: any[] = [];
  public stageToApprove: any;
  public currentStages:any [] = [];
  public isShowApprovalMessage: boolean = false;
  public remainingAligners:number=0;
  public remainingCaseUpperAligners:number=0;
  public remainingCaseLowerAligners:number=0;
  public fabricatedUpperAligners:number=0;
  public fabricatedLowerAligners:number=0;
  public disableEditAligners:boolean=false;
  public disableAcceptSetup:boolean=false;
  public hasSetupMechanics:boolean=false;
  public statusList: any;
  public selectedSetupCorrection: number = 1;
  public displayedColumns: any[] = [
    { property: 'code', display: 'Código', pipe: null },
    { property: 'patientFullName', display: 'Datos del paciente', pipe: null },
    { property: 'patientEmail', display: 'Correo electrónico', pipe: null },
    { property: 'caseStageUpperAligners', display: 'Alineadores superiores', pipe: null },
    { property: 'caseStageLowerAligners', display: 'Alineadores inferiores', pipe: null },
    { property: 'stageCount', display: 'Etapa', pipe: null },
    { property: '',display: 'Link de setup', pipe : null},
    { property: '', display: 'Acciones', pipe: null }
  ];

  public setupCorrectionsOptions: any[] = [
    { value: 1,name:'samePlanCorrection', label: 'Correción sobre el mismo plan', description: "Favor de indicar detalles que te gustaría modificar de este plan" },
    { value: 2, name:'treatementChanges', label: 'Cambios de plan de tratamiento', description: "Favor de escribir con detalle el plan de tratamiento nuevo que deseas" },
    { value: 3, name:'requestLessQuantity', label: 'Solicitar menos alineadores totales', description: "Indicar los movimientos que deseas limitar o eliminar para reducir el número de alineadores" }
  ];


  public columnsToDisplay: any[] = this.displayedColumns.map(col => col.display);
  public inShippingAddressSelectionProcess: boolean = false;
  public shippingAddressSelectionProcess: number = 1;
  public customerAddresses: any;
  public exceptionAddresses: any;
  public addressList: any;
  public previousAddress: any;
  public defaultAddress: any;
  public selectedAddress: any;
  public isApproveWithChanges: boolean = false;
  public updateAlignersValidationsPassed: boolean = true;
  public alignersFormValue: any;
  public maxHoursToUpdateDate: number = 0;
  public isApproveChecked: boolean = false;
  public correctionValues: string[] = Array(this.setupCorrectionsOptions.length).fill('');
  constructor(title: Title,
    caseDataService: CaseDataService,
    private router: Router,
    private customerDataService: CustomerDataService,
    public statusManagerService: StatusManagerService,
    private statusDataService: StatusDataService,
    private caseStageDataService: CaseStageDataService,
    private addressExceptionsDataService: AddressExceptionsDataService,
    private customerAddressDataService: CustomerAddressDataService,
    private systemConfigDataService: SystemConfigDataService
  )
  {
    super("Casos", title, caseDataService);
    this.getStatusHasRequiresSufficientAlignersAvailableFlagActivated();
  }

  ngOnInit()
  {
    this.isLoading = true;
    this.getCustomerInfo();
    this.getAllStatus();
    this.getStatusInfo();
    BroadcastManager.Instance.on(AppEventNames.onUseNewAligners)
      .subscribe(([response]:any) =>
      {
        this.case.usedUpperAligners=response[0];
        this.case.usedLowerAligners=response[1];
        this.update();
      });
    super.ngOnInit();
  }

  getStatusHasRequiresSufficientAlignersAvailableFlagActivated(){
    let queryDef = new UrlQueryDef();
    queryDef.addParam("requiresSufficientAlignersAvailable", true);
    this.statusDataService.getStatusesByFlag(queryDef).subscribe(res=>{
      this.orderStatusToValidateAligners = res[0].order;
      this.statusIdToValidateAligners = res[0].id;
    }, err=>{
      this.setWarningAlert('No existe status para calcular etapas fabricadas, revise la configuración de estatus, e intente de nuevo.');
    })
  }

  public update()
  {
    this.dataService.updateCase(this.case).subscribe((response)=>{
      this.case=response;
    })
  }

  public getAllStatus(): void
  {
    let queryDef = new UrlQueryDef();
    this.statusDataService.get(queryDef)
    .subscribe((response: any) =>
    {
      this.statusList = response.rows;
      this.statusOptions.push({ "name": "Todos los status", "value": 0 });
      for (let i = 0; i < response.rows.length; i++)
      {
        this.statusOptions.push({
          "name": response.rows[i].name,
          "value": response.rows[i].id
        });
      }
    }, (fail: any) =>
    {
      this.setWarningAlert(fail.error.message);
    });
  }

  public getCustomerInfo()
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id).subscribe((res: any) => {
        this.customerId = res.items[0].id;
        if (this.pagination) {
          this.pagination.getPage(this.pagination.pageNumber, this.pagination.pageSize)
            .subscribe(response => {
              this.getAddresses();
              this.onAfterGetAll();
            });
        }
      });

    }
    else
    {
      this.router.navigate(['/ecommerce']);
    }
  }

  public onCreateNewCase(): void
  {
    this.router.navigate(['/ecommerce/mis-casos/nuevo-caso/paciente']);
  }

  protected onSelect(item: any): void
  {
    if (item.isPartialSave)
      this.router.navigate(['/ecommerce/mis-casos/nuevo-caso/paciente/'+item.patientId], {queryParams: {'caseId': item.id}});
    else
      this.router.navigate(['/ecommerce/mis-casos/detail', item.id]);
  }

  public getBackgroundColor(columnName: string, element: any): string
  {
    return columnName === 'Estatus' ? element['statusColor'] : 'transparent';
  }

  public getColor(columnName: string, element: any): string
  {
    return columnName === 'Estatus' && element['statusColor'] != 'transparent' ? '#fff' : '#333';
  }

  // ********************************************************************************
  // #region Methods Overrides
  // ********************************************************************************
  protected onRegisterEventListeners()
  {
    super.onRegisterEventListeners();
  }


  public override getAll(paged: boolean = false): void
  {
    if (AppClientContext.Instance.user) {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id).subscribe((res: any) => {
        this.customerId = res.items[0].id;
        if (this.pagination) {
          this.pagination.getPage(this.pagination.pageNumber, this.pagination.pageSize)
            .subscribe(response => {
              this.onAfterGetAll();
              this.dataService.getAllCasesFiltered(this.getQueryDefForGetAll())
                .subscribe((response: any) => {
                  //Check if we have a paged result
                  if (response.records != undefined && response.totalRecords != undefined) {
                    this.dataRows = response.records;
                    this.totalRows = response.totalRecords;
                  }
                  else {
                    this.dataRows = response;
                  }

                  if (this.paginator && !paged)
                    this.paginator.firstPage();

                  this.dataRowsCopy = this.dataRows;
                  this.onAfterGetAll();
                });
            });
        }
      });

    }
    else {
      this.router.navigate(['/ecommerce']);
    }

  }


  protected override onAfterGetAll()
  {
    this.dataSource = new MatTableDataSource<any>(this.dataRows);
    this.dataSource.sortingDataAccessor = Tools.sortingDataAccessor;
    this.dataSource.sort = this.sort;
    this.isLoading = false;

    //super.onAfterGetAll();
  }

  protected onGetQueryDefForGetAll(queryDef: UrlQueryDef)
  {
    queryDef.params = {};
    queryDef.includes = 'Patient,Product';
    if(this.paginator){
      queryDef.params['pageNo'] = this.paginator.pageIndex + 1;
      queryDef.params['pageSize'] = this.paginator.pageSize;
    }

    queryDef.params['statusId'] = this.statusIdToValidateAligners;
    queryDef.params['isPartialSave'] = false;
    queryDef.params['isDeleted'] = false;
    if(this.customerId){
      queryDef.params['customerId']= this.customerId;
    }
    queryDef.params['requestFrom'] = 2;


    super.onGetQueryDefForGetAll(queryDef);
  }

  public onGetFilteredResults(): void
  {
    this.pagination.setPageNumber = 0;
    this.getAll();
  }

  public isPendingToApprove(element: any): boolean
  {
    return element.orderStatus==this.orderStatusToValidateAligners && !element.isPendingToReviewAlignersQuantity;
  }

  public onHandleReviewStage(caseStage: any): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = 'Product';
    this.caseId=caseStage.caseId;
    this.stageToApprove = caseStage;
    this.disableAcceptSetup = false;
    this.hasSetupMechanics = false;
    this.isApproveChecked = false;
    if(this.stageToApprove.setupMechanics != "Sin mecánicas de setup")
    {
      this.disableAcceptSetup = true;
      this.hasSetupMechanics = true;
    }
    this.dataService.getById(this.caseId,queryDef).subscribe((response)=>{
      this.case=response;
      this.getRemainingAligners(false);
      this.getAllCaseStages();
      this.shippingAddressSelectionProcess = 1;
      this.approvalDialog.show = true;
    });
    
  }

  public onAcceptSetup(): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;
    queryDef.params['setUpAcceptedAction'] = true;
    this.dataService.getUsedAlignersByCase(queryDef).subscribe(res => {
      this.statusManagerService.setCurrentCaseStage(this.stageToApprove);
      let totalAligners = this.stageToApprove.caseStageUpperAligners + this.stageToApprove.caseStageLowerAligners;

      if (this.case.productId != null && (this.case.productHasUnlimtedAligners || totalAligners <= this.remainingAligners)) 
      {
        this.onUpdateStatus(true, res.usedUpperAligners, res.usedLowerAligners);
      }
      else 
      {
        this.setInfoAlert("No cuentas con alineadores suficientes adquiridos."+ "Tienes "+this.remainingAligners+ " alineadores disponibles.");
      }

    })  
  }

  public getRemainingAligners(setUpAcceptedAction:boolean)
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;
    queryDef.params['setUpAcceptedAction'] = setUpAcceptedAction;
    this.dataService.getUsedAlignersByCase(queryDef).subscribe(res => {
      this.statusManagerService.setCurrentCaseStage(this.stageToApprove);
      this.remainingAligners = this.case.totalAligners - (res.usedUpperAligners+res.usedLowerAligners);
      this.remainingCaseUpperAligners=this.case.upperAligners - res.usedUpperAligners;
      this.remainingCaseLowerAligners=this.case.lowerAligners - res.usedLowerAligners;
      this.fabricatedLowerAligners=res.usedLowerAligners;
      this.fabricatedUpperAligners=res.usedUpperAligners;
      if(this.remainingCaseLowerAligners+this.remainingCaseUpperAligners < 16){
        this.disableEditAligners=true;
      }
    })  
  }

  public onUpdateStatus(isNextStatus: boolean, usedUpperAligners: number, usedLowerAligners: number): void
  {
    // Change order status
    let order = isNextStatus ? this.currentStatus.order+1 : this.currentStatus.order-1;
    // Get next or previous status
    let status = this.statusManagerService.getStatusInfo().find(x => x.order == order);

    if(isNextStatus)
    {
      let [canGoNextStatus, message] = this.statusManagerService.validateNextStatus();

      if(!canGoNextStatus)
      {
        this.setInfoAlert(message);
        this.approvalDialog.show = false;
        return;
      }
    }

    let body =
    {
      id: this.stageToApprove.currentCaseStageId,
      caseId: this.caseId,
      statusId: status.id,
      stageNumber: this.stageToApprove.stageCount,
      comments: `Cambio de estatus a ${status.name}, en la etapa ${this.stageToApprove.stageCount}`
    };

    this.caseStageDataService.updateStatus(body)
      .subscribe(response =>
      {
        this.onUpdateCaseStageCustomerAddress();
        this.setSuccessAlert("Estatus actualizado con éxito.");
        this.approvalDialog.show = false;
        BroadcastManager.Instance.broadcast(AppEventNames.onUseNewAligners, usedUpperAligners, usedLowerAligners);
        this.getAll();
      }, (fail) =>
      {

      });
  }

  public onRefuseSetup(): void
  {
    this.isShowApprovalMessage = true;
  }

  public onUpdateAligners(): void
  {
    let aligners = this.alignersForm.value;
    this.alignersFormValue = aligners;
    let totalAligners = aligners.upperAligners + aligners.lowerAligners;
    if (totalAligners >= 16)
    {
      if (this.alignersForm.valid && (this.case.productHasUnlimtedAligners || totalAligners <= this.remainingAligners)) 
      {
        if ((aligners.upperAligners <= this.remainingCaseUpperAligners) && (aligners.lowerAligners <= this.remainingCaseLowerAligners)) 
        {
          this.updateAlignersValidationsPassed = true;
          this.goToShippingAddressSelection(true);
        }
        else
        {
          this.setInfoAlert("No cuentas con alineadores suficientes en el caso. " +"Restan "+this.remainingCaseUpperAligners+" alineadores superiores y "+this.remainingCaseLowerAligners+" alineadores inferiores por fabricar.");
        }
      }
      else 
      {
        this.setInfoAlert("No cuentas con alineadores suficientes adquiridos. " +"Tienes " +this.remainingAligners+" disponibles.");
      }
    }
    else 
    {
            //extra validations with product with less than 16 aligners
      if (this.case.productAlignersQuantity >= 16) {
        if ((this.remainingCaseLowerAligners + this.remainingCaseUpperAligners) >= 16) {
          this.setDangerAlert("La cantidad mínima de alineadores por etapa es de 16, ingrese una cantidad mayor.");
        }
        else {
          //guardar
        }
      }
      else
      {
        if ((aligners.upperAligners + aligners.lowerAligners) > this.remainingAligners) {
          this.setInfoAlert("No cuentas con alineadores suficientes adquiridos. " + "Tienes " + this.remainingAligners + " alineadores disponibles.");
        }
        else if ((aligners.upperAligners + aligners.lowerAligners) < this.case.productAlignersQuantity && this.remainingAligners > 0) {
          this.setInfoAlert("No es posible fabricar una cantidad de alineadores menor a la disponible en el paquete contratado. " + "Tienes " + this.case.productAlignersQuantity + " alineadores disponibles.");
        }
        else if ((aligners.upperAligners + aligners.lowerAligners) == this.case.productAlignersQuantity && this.remainingAligners > 0)
        {
          this.updateAlignersValidationsPassed = true;
          this.goToShippingAddressSelection(true);
        }

      }
    }

  }

  public updateCaseStageAligners()
  {
    let body = this.alignersFormValue;
    body['id'] = this.stageToApprove.currentCaseStageId;
    body['IsPendingToReviewAlignersQuantity'] = false;
    
    this.caseStageDataService.updateAligners(body)
      .subscribe(response => {
        this.setSuccessAlert("Información enviada correctamente");
        this.isShowApprovalMessage = false;
        this.approvalDialog.show = false;
        this.stageToApprove.caseStageUpperAligners = this.alignersFormValue.upperAligners;
        this.stageToApprove.caseStageLowerAligners = this.alignersFormValue.lowerAligners;
        this.statusManagerService.setCurrentCaseStage(this.stageToApprove);
        this.isApproveWithChanges = false;
        this.onAcceptSetup();
      }, (fail => {
        this.setDangerAlert(fail.error.message);
      }));
  }

  public get currentStatus(): Status
  {
    return this.statusManagerService.currentStatus;
  }
  
  private getStatusInfo(): void
  {
    this.statusDataService.get()
      .subscribe(response =>
      {
        this.statusManagerService.setStatusInfo(response.rows);
      });
  }

  goToSetupLink(element:any) :void
  {
    if(element.setupLink.includes('http')||element.setupLink.includes('https'))
    {
      window.open(element.setupLink, '_blank','noreferrer');
      
    }
    else{
      window.open('http://'+element.setupLink, '_blank','noreferrer');
    }

    
  }

  public onCancelStage(): void
  {
    this.deleteDialog.show = true;
  }

  public onSuggestAlignersByAliwell(element: any): void
  {
    if(!this.setupInUse())
    {
      this.suggestAlignersByAliwellDialog.show = true;
    }
    else{
      this.setInfoAlert("No se pueden realizar cambios a un setup previamente utilizado.");
    }
    
  }

  private getQueryDefEcommerceConfig(): any
  {
    return new UrlQueryDef().getRequestConfig(true);
  }

  public onDeleteCaseStage(): void
  {
    
    this.caseStageDataService.delete(this.stageToApprove.currentCaseStageId, this.getQueryDefEcommerceConfig())
      .subscribe(response =>
      {
        this.setSuccessAlert('Etapa cancelada satisfactoriamente');
        this.deleteDialog.show = false;
        this.approvalDialog.show = false;
        this.getAll();

      }, fail =>
      {
        this.setDangerAlert(fail.error);
      });
  }

  public onAddComments(): void 
  {
    let correctionOptionsLabel = this.setupCorrectionsOptions.find(x => x.value == this.selectedSetupCorrection).label;
    let comments = (this.correctionValues[0] != "" ? this.correctionValues[0]  : this.correctionValues[1]  != "" ? this.correctionValues[1] : this.correctionValues[2]);
    if (comments) {
      let body =
      {
        id: this.stageToApprove.currentCaseStageId,
        caseId: this.caseId,
        statusId: StatusesID.SetupChanges,
        stageNumber: this.stageToApprove.stageCount,
        commentsBackoffice: "Cantidad previa de alineadores totales requeridos. Superiores: " + this.case.upperAligners + " Inferiores: " + this.case.lowerAligners + ". " + correctionOptionsLabel + ". Comentarios: " + comments,
        commentsEcommerce: "Cantidad previa de alineadores totales requeridos. Superiores: " + this.case.upperAligners + " Inferiores: " + this.case.lowerAligners + ". " + correctionOptionsLabel +  ". Comentarios: " + comments,
        changeType: this.selectedSetupCorrection,
        setupChangesComments: "Cantidad previa de alineadores totales requeridos. Superiores: " + this.case.upperAligners + " Inferiores: " + this.case.lowerAligners + ". " + correctionOptionsLabel +  ". Comentarios: " + comments,
        isRequestChangeSetup: true
      };
      this.caseStageDataService.updateStatus(body)
        .subscribe(() => {
          this.suggestAlignersByAliwellDialog.show = false;
          this.approvalDialog.show = false;
          this.setInfoAlert("Se cambió a estatus Cambios de setup y los comentarios fueron enviados correctamente.");
          this.getAll();
        });
    }
    else {
      this.setInfoAlert("Es necesario ingresar los detalles de la opción seleccionada para continuar");
    }

  }

  public setupInUse() : boolean
  {
    let currentSetup= this.currentStages.find(x => x.stageNumber == this.stageToApprove.stageCount);
    let currentSetupStages:any [] = this.currentStages.filter(x => x.setupId == currentSetup.setupId);
    return currentSetupStages.length > 1 ? true : false;
  }

  private getAllCaseStages(): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.filter = "CaseId eq " + this.caseId;
    queryDef.orderby = "StageNumber,CreatedDate desc"
    if(this.stageToApprove.caseId)
    {
      this.caseStageDataService.get(queryDef)
        .subscribe((response: any) =>
        {
          this.currentStages = response?.rows != null ? response?.rows : [];
        });
    }
  }

  public onCheckboxChange(e:any)
  {
    if(e == true)
    {
      this.disableAcceptSetup = false;
    }
    else{
      this.disableAcceptSetup = true;
    }
  }

  public getMaxHoursToSetAddress()
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {
      key : 'MaxHoursToSetAddress'
    };
    this.systemConfigDataService.getSystemConfigValueByKey(queryDef)
    .subscribe((res)=>{
      this.maxHoursToUpdateDate = res.value;
    })
  }

  public getAddresses() : void
  {

    this.customerAddressDataService.getCustomerAddressByCustomerId(this.customerId)
    .subscribe((res)=>{
      this.customerAddresses = res;
      this.addressExceptionsDataService.getAddressExceptions(this.getQueryDefForGetAll())
      .subscribe((res2)=>{
        this.exceptionAddresses = res2;
        this.exceptionAddresses = this.exceptionAddresses.map(x=>  ({
          ...x,           // Spread the existing properties
          isAddressException : true
        })
           );
        this.addressList = this.customerAddresses.concat(this.exceptionAddresses);
        this.defaultAddress = this.addressList.find(x=> x.isDefault == true);
        this.selectedAddress = this.defaultAddress;
        this.getMaxHoursToSetAddress();
      });

    })
   
  } 

  public goToShippingAddressSelection(isApproveWithChanges: boolean)
  {
    this.isApproveWithChanges = isApproveWithChanges;
    this.shippingAddressSelectionProcess = 2;
  }

  public onShippingAddressChange()
  {
    this.previousAddress = this.selectedAddress;
    this.shippingAddressSelectionProcess = 3;
  }

  public onGoToCustomerProfileConfirmation()
  {
    this.shippingAddressSelectionProcess = 4;
  }

  public onGoToCustomerProfile()
  {
    this.router.navigate(['/ecommerce/mi-perfil']);
  }

  public onCancelAddressAssign()
  {
    this.selectedAddress = this.defaultAddress;
    this.updateAlignersValidationsPassed = false;
    this.shippingAddressSelectionProcess = 1;

    if (this.stageToApprove.setupMechanics != "Sin mecánicas de setup") 
    {
      this.disableAcceptSetup = true;
      this.hasSetupMechanics = true;
    }
    this.isApproveChecked = false;
  }

  public onBackToMainPage()
  {
    this.isShowApprovalMessage = false 
    if (this.stageToApprove.setupMechanics != "Sin mecánicas de setup") 
      {
        this.disableAcceptSetup = true;
        this.hasSetupMechanics = true;
      }
      this.isApproveChecked = false;
  }

  public onCancelAddressSelection2()
  {
    this.selectedAddress = this.previousAddress
    this.shippingAddressSelectionProcess = 2;
  }

  public onUpdateCaseStageCustomerAddress()
  {
    let body =
    {
      id: this.stageToApprove.currentCaseStageId,
      addressId: this.selectedAddress.id,
      isAddressException: this.selectedAddress.isAddressException ? true : false,
      customerId: this.customerId
    };
    this.caseStageDataService.updateCaseStageCustomerAddress(body)
    .subscribe((res)=>
    {
      this.setInfoAlert("Dirección asignada a etapa correctamente");
    });
  }

  public onConfirmSetup()
  {
    if(this.isApproveWithChanges)
    {
      this.updateCaseStageAligners();
    }
    else
    {
      this.onAcceptSetup();
    }
  }

  public onSelectionChange(event: MatRadioChange) {
    this.previousAddress = this.selectedAddress;
    this.selectedAddress = event.value;
  }

  public onCancelAddressEdition()
  {
    this.shippingAddressSelectionProcess = 3;
  }

  public onSetupCorrectionSelectionChange()
  {
    this.correctionValues = Array(this.setupCorrectionsOptions.length).fill('');
  }



}
